import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { pmaActions } from "_store/_actions";
import YEOne from "./YEOne";
import YETwo from "./YETwo";

class YearEnd2022 extends Component {
  render() {
    const {
      printVersion,
      fromEditor,
      pdfPrintVersion,
      version,
      agentData,
      hoData,
      currentArea,
      coverPageDetails,
      testimonials,
      yearEnd,
      quarterlyAreaTable,
      quarterlyCityTable,
      demoAccountAreaName,
      demoAccountCoverPhoto,
      aprilData,
      propertyPhotoDetailsDTO,
      pmaQuarterlyCombinedCityDTO,
      quadrantDetails,
      oldPhotoDetails,
      photoTableData,
      isDemo,
      MQCityDetails,
      bubbleBoxes,
      missionStatement,
      hasFlippedTeam,
      altAgentData,
      volunteerDetails,
      dashboardValuation,
      miniTableDetailsDTO,
      agentFocusInfoList,
      designDetailsInfoList,
      tpTrends2WatchList,
      showAllEditButtons,
      keyMarketAvgsList,
      showMedian,
      priceRangeDashBoardDetailsDTOArea,
      priceRangeDashBoardDetailsDTOCity,
    } = this.props;
    const nonPrintStyle = {
      padding: "10px 0 25px 0",
    };

    if (version === "year-end-2022") {
      return (
        <Fragment>
          <div
            className={
              "pma-editor " +
              (printVersion ? "ye-print" : "") +
              (pdfPrintVersion ? " pdf-print-version" : "")
            }
            style={printVersion ? null : nonPrintStyle}
          >
            <div id="back-to-top-anchor-pma-editor-page-1" />
            <YETwo
              agentData={agentData}
              hoData={hoData}
              currentArea={currentArea}
              printVersion={printVersion}
              fromEditor={fromEditor}
              pdfPrintVersion={pdfPrintVersion}
              version={version}
              coverPageDetails={coverPageDetails}
              testimonials={testimonials}
              yearEnd={yearEnd}
              demoAccountAreaName={demoAccountAreaName}
              demoAccountCoverPhoto={demoAccountCoverPhoto}
              aprilData={aprilData}
              propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
              pmaQuarterlyCombinedCityDTO={pmaQuarterlyCombinedCityDTO}
              quarterlyAreaTable={quarterlyAreaTable}
              quadrantDetails={quadrantDetails}
              agentFocusInfoList={agentFocusInfoList}
              designDetailsInfoList={designDetailsInfoList}
              tpTrends2WatchList={tpTrends2WatchList}
              oldPhotoDetails={oldPhotoDetails}
              photoTableData={photoTableData}
              quarterlyCityTable={quarterlyCityTable}
              isDemo={isDemo}
              MQCityDetails={MQCityDetails}
              bubbleBoxes={bubbleBoxes}
              missionStatement={missionStatement}
              hasFlippedTeam={hasFlippedTeam}
              altAgentData={altAgentData}
              volunteerDetails={volunteerDetails}
              dashboardValuation={dashboardValuation}
              miniTableDetailsDTO={miniTableDetailsDTO}
              showAllEditButtons={showAllEditButtons}
              keyMarketAvgsList={keyMarketAvgsList}
              showMedian={showMedian}
              priceRangeDashBoardDetailsDTOArea={
                priceRangeDashBoardDetailsDTOArea
              }
              priceRangeDashBoardDetailsDTOCity={
                priceRangeDashBoardDetailsDTOCity
              }
            />
            <div id="back-to-top-anchor-pma-editor-page-2" />
          </div>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <div
            className={
              "pma-editor " +
              (printVersion ? "ye-print" : "") +
              (pdfPrintVersion ? " pdf-print-version" : "")
            }
            style={printVersion ? null : nonPrintStyle}
          >
            <div id="back-to-top-anchor-pma-editor-page-1" />
            <YEOne
              agentData={agentData}
              hoData={hoData}
              currentArea={currentArea}
              printVersion={printVersion}
              pdfPrintVersion={pdfPrintVersion}
              version={version}
              coverPageDetails={coverPageDetails}
              testimonials={testimonials}
              yearEnd={yearEnd}
              demoAccountAreaName={demoAccountAreaName}
              demoAccountCoverPhoto={demoAccountCoverPhoto}
            />
            <div id="back-to-top-anchor-pma-editor-page-2" />
          </div>
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.pma.isLoading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    changeLoading: (status) => {
      dispatch(pmaActions.changeLoading(status));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(YearEnd2022);
